export enum LocalStorageKeys {
  CreatingWorkspaceForOrgController = 'CREATING_WORKSPACE_FOR_ORG_CONTROLLER',
}
